import { render, staticRenderFns } from "./business-contact-data.vue?vue&type=template&id=02d1b756&"
import script from "./business-contact-data.vue?vue&type=script&lang=js&"
export * from "./business-contact-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports